import React from 'react'
import { Routes, Route } from 'react-router-dom'
import PrivateRoute from '~components/PrivateRoute'
import PrivateStockistRoute from '~components/PrivateStockistRoute'
import Dashboard from '~components/pages/Dashboard'
import Page from '~components/pages/Page'
import ShopIndex from '~components/pages/shop/Index'
import ShopBrand from '~components/pages/shop/Brand'
import ShopRange from '~components/pages/shop/Range'
import ShopStyle from '~components/pages/shop/Style'
import ShopCart from '~components/pages/shop/Cart'
import Login from '~components/pages/account/Login'
import Register from '~components/pages/account/Register'
import ForgotPassword from '~components/pages/account/ForgotPassword'
import ResetPassword from '~components/pages/account/ResetPassword'
import Setup from '~components/pages/account/Setup'
import Account from '~components/pages/account/Account'
import MediaHub from '~components/pages/MediaHub'
import Confirmation from '~components/pages/shop/Confirmation'
import Orders from '~components/pages/account/orders/Orders'
import Order from '~components/pages/account/orders/Order'
import Payment from '~components/pages/account/Payment'
import Invoices from '~components/pages/account/Invoices'
import Details from '~components/pages/account/Details'

const RoutesComponent = () => {
  return (
    <Routes>
      <Route
        path="/" element={<PrivateRoute>
          <Dashboard />
        </PrivateRoute>}
      />
      <Route
        path="/shop" element={<PrivateStockistRoute>
          <ShopIndex />
        </PrivateStockistRoute>}
      />
      <Route
        path="/shop/brands/:brand" element={<PrivateStockistRoute>
          <ShopBrand />
        </PrivateStockistRoute>}
      />
      <Route
        path="/shop/ranges/:range" element={<PrivateStockistRoute>
          <ShopRange />
        </PrivateStockistRoute>}
      />
      <Route
        path="/shop/ranges/:range/:style" element={<PrivateStockistRoute>
          <ShopStyle />
        </PrivateStockistRoute>}
      />
      <Route
        path="/basket" element={<PrivateStockistRoute>
          <ShopCart />
        </PrivateStockistRoute>}
      />
      <Route
        path="/basket/:dialog" element={<PrivateStockistRoute>
          <ShopCart />
        </PrivateStockistRoute>}
      />
      <Route
        path="/shop/confirmation" element={<PrivateStockistRoute>
          <Confirmation />
        </PrivateStockistRoute>}
      />
      <Route
        path="/media-hub" element={<PrivateStockistRoute>
          <MediaHub />
        </PrivateStockistRoute>}
      />
      <Route path="/account/login" element={<Login />} />
      <Route path="/account/register" element={<Register />} />
      <Route path="/account/forgot" element={<ForgotPassword />} />
      <Route path="/account/reset/:token/:email" element={<ResetPassword />} />
      <Route path="/account/setup/:user" element={<Setup />} />
      <Route
        path="/account" element={<PrivateRoute>
          <Account>
            <Details />
          </Account>
        </PrivateRoute>}
      />
      <Route
        path="/account/orders" element={<PrivateRoute>
          <Account>
            <Orders />
          </Account>
        </PrivateRoute>}
      />
      <Route
        path="/account/orders/:order_id" element={<PrivateRoute>
          <Account>
            <Order />
          </Account>
        </PrivateRoute>}
      />
      <Route
        path="/account/payment" element={<PrivateRoute>
          <Account>
            <Payment />
          </Account>
        </PrivateRoute>}
      />
      <Route
        path="/account/invoices" element={<PrivateRoute>
          <Account>
            <Invoices />
          </Account>
        </PrivateRoute>}
      />
      <Route path="/terms" element={<Page />} />
      <Route path="/privacy" element={<Page />} />
      <Route path="/accessibility" element={<Page />} />
      <Route path="/cookie" element={<Page />} />
      <Route path="/help" element={<Page />} />
    </Routes>
  )
}

export default RoutesComponent
